// @ts-nocheck
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet-async';
import "../css/normalize.css";

//ヘッダー
import Header from "../component/page_parts/header";

// インフォメーション一覧
import TopInformationList from "../component/page_parts/top_information_list";

// イベント情報
import CompanyEventList from "../component/page_parts/company_event_list";

//サブサイドバー
import TopSubSidebar from "../component/page_parts/common/top_sub_sidebar";

//myカレンダー
import MyCalendar from "../component/page_parts/myCalendar";

// カスタマイズ
import CustomizeHome from "../component/page_parts/customize_home";

// import XTimelineEmbed from "../component/page_parts/x_Timeline_Embed";

import Luckyitem from "../component/page_parts/luckyitem";

// フッター
import Footer from "../component/page_parts/footer";

const baseUrl = process.env.REACT_APP_PUBLIC_URL || '';

// GAID
const gaId = process.env.REACT_APP_GA_ID;

const usePageTracking = () => {
  const location = useLocation();


  useEffect(() => {

    // Google Analytics 測定 ID を入力して設定
    ReactGA.initialize(gaId);
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname,
      title: pageTitle
    });
  }, [location]);
};

function Home() {

  return (

    <>

      <Helmet>

        <title>Z-link ホーム</title>

      </Helmet>
      <Header />

      <TopSubSidebar />

      <div className="theme-index container">

        <div className="banner-area-main">
          <div className="banner-area">
            {/* <a className="service-banner mini" href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5044" target="_blank">
              <img
                className=""
                src={process.env.PUBLIC_URL + '/banner13.png'}
              />
            </a> */}
            {/* <a className="service-banner mini" href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5048" target="_blank">
              <img
                className=""
                src={process.env.PUBLIC_URL + '/banner14.png'}
              />
            </a> */}
            {/* <a className="service-banner" href="https://contents.xj-storage.jp/xcontents/AS81530/1b5e0ce3/3a55/42e8/9bcc/33e252f3a4be/20250828150811407s.pdf" target="_blank">
              <img
                className=""
                src={process.env.PUBLIC_URL + '/banner6.png'}
              />
            </a> */}
            <a className="service-banner short" href="https://script.google.com/a/macros/zenken.co.jp/s/AKfycbweRtyNj6W4kwkmEg4wYV5ZuJZJc-qPz9-7RLt4LcAJu00NmTE31KqYLZep0ahX3GN1FQ/exec" target="_blank">
              <img
                className=""
                src={process.env.PUBLIC_URL + '/banner9.png'}
              />
            </a>
            <a className="service-banner short" href="https://notebooklm.google.com/notebook/9c0b4ac7-c31c-4e45-80a0-758a5a9c925f" target="_blank">
              <img
                className=""
                src={process.env.PUBLIC_URL + '/banner10.png'}
              />
            </a>
            <a className="service-banner short" href="https://www.youtube.com/watch?v=aR30mUpMrnY" target="_blank">
              <img
                className=""
                src={process.env.PUBLIC_URL + '/banner5.png'}
              />
            </a>
          </div>
        </div>

        <TopInformationList />

        <MyCalendar />

        <CompanyEventList />

        <div className="service-area">
          <a className="service-banner" href="https://zenken-career.jp/life-care/" target="_blank">
            <img
              className=""
              src={process.env.PUBLIC_URL + '/ssw-service-banner.png'}
            />
          </a>
          <a className="service-banner" href="https://www.the-engagementor.com/" target="_blank">
            <img
              className=""
              src={process.env.PUBLIC_URL + '/engagementor.png'}
            />
          </a>
          <a className="service-banner" href="https://docs.google.com/forms/d/e/1FAIpQLSeM_4qBcYAd04fSy0_BLOLCK0tVoqeFDQqfm17VuX3vMgrqpA/viewform" target="_blank">
            <img
              className=""
              src={process.env.PUBLIC_URL + '/tosupo.png'}
            />
          </a>
        </div>

        <div className="service-area-mini">
          <a className="service-banner" href={baseUrl + '/logoguide'}>
            <img
              className=""
              src={process.env.PUBLIC_URL + '/zenken-logo-collection.png'}
            />
          </a>
        </div>

        <CustomizeHome />

      </div>
      <Footer />

    </>
  );

}

export default Home;
